import { useEffect } from "react";
import { motion } from "framer-motion";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";
import TypeIt from "typeit";
import DL from "../img/blank_dl.png";
import DLCourseDetail1 from "../components/DLCourseDetail1";
import DLCourseDetail2 from "../components/DLCourseDetail2";
import Creative from "../img/Innovation-amico.png";
import Sudoku from "../img/Sudoku-pana.png";

const DLPage = () => {
  useEffect(() => {
    new TypeIt("#element", {
      strings: ["AI 人工智能：深度學習 從原理到實作"],
      speed: 100,
      afterComplete: (instance) => {
        const el = document.querySelector("#element");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element2", {
      strings:
        "35小時完整課程，帶你系統性理解深度學習核心概念與實務應用，並深入掌握 CNN、ResNet、LSTM、Transformer、BERT、GPT、GAN、VAE 與 Diffusion 等主流模型架構與建模方法，結合理論與實作!",
      speed: 15,
      startDelay: 1500,
      loop: false,
      afterComplete: (instance) => {
        const el = document.querySelector("#element2");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();
  }, []);

  return (
    <div>
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        className="webdev"
        exit="exit"
      >
        <div className="img">
          <img src={DL} alt="" />
        </div>
        <div className="desc">
          <h1>
            <span id="element"></span>
          </h1>
          <div className="content">
            <h3 id="element2"></h3>
          </div>

          <div>
            <p>
              課程價格: <span className="hide">新台幣$290</span>{" "}
            </p>
            <p>
              優惠代碼(點擊連結即可自動套用優惠碼):
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/wilson-deep-learning/?couponCode=${process.env.REACT_APP_DEEP_LEARNING_COUPON}`}
              >
                <span>{process.env.REACT_APP_DEEP_LEARNING_COUPON}</span>
              </a>
              (只到
              <span style={{ color: "red" }}>{process.env.REACT_APP_DATE}</span>
              之前有效)
            </p>
            <p>
              課程連結:
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/wilson-deep-learning/?couponCode=${process.env.REACT_APP_DEEP_LEARNING_COUPON}`}
              >
                <span className="hide">
                  https://www.udemy.com/course/wilson-deep-learning/
                </span>
              </a>
            </p>
          </div>
          {/* <div
            className="coming-soon"
            style={{
              marginTop: "20px",
              fontSize: "18px",
              fontWeight: "600",
              color: "#aaa",
            }}
          >
            深度學習課程正在準備中，將於近期正式上線，敬請期待完整內容發布！
          </div> */}
        </div>
        <DLCourseDetail1 img={Creative} />
        <DLCourseDetail2 img={Sudoku} />
        <ScrollTop />
      </motion.div>
    </div>
  );
};

export default DLPage;
